import React from 'react'
import Container from '../components/Container'
import {news} from '../constants/data/news';
import NewsCard from '../components/Cards/NewsCard';

const News = () => {

  return (
    <>
      <div>
        <h1 className="text-white font-bold text-center bg-primary py-8">الاخبار</h1>
      </div>
      <Container>
        <div className='grid gap-4 justify-items-center md:grid-cols-2 md:justify-items-start lg:grid-cols-3'>
          {news.map((item, index) => {
            return <NewsCard key={index} item={item} />
          })}
        </div>
      </Container>
    </>
  )
}

export default News